import { createAction } from 'redux-actions';
import { NotificationType } from '../api/types';

export interface FetchLocationsPayload {
}

export interface UpdateLocationPayload {
    id: string;
    enabled: boolean;
    status: {
        bookable: boolean;
        notification?: {
            type: NotificationType;
            text: string;
        };
    };
}

export interface FetchLocationBookingStatsPayload {
    locationId: number;
}

export interface FetchAllAssetGroupsPayload {
}

export interface FetchLocationAvailabilitiesPayload {
    locationId: string;
    assetGroupId: string;
    fromDate: Date;
    toDate: Date;
}

export const fetchLocations = createAction<FetchLocationsPayload>('FETCH_LOCATIONS');
export const updateLocation = createAction<UpdateLocationPayload>('UPDATE_LOCATION');
export const fetchLocationBookingStats = createAction<FetchLocationBookingStatsPayload>('FETCH_LOCATION_BOOKING_STATS');
export const fetchAllAssetGroups = createAction<FetchAllAssetGroupsPayload>('FETCH_ALL_ASSETGROUPS');
export const fetchLocationAvailabilities = createAction<FetchLocationAvailabilitiesPayload>(
    'FETCH_LOCATION_AVAILABILITIES');
